import { ng } from '@uirouter/angularjs/lib/angular';
import { StateParams, StateService } from '@uirouter/core';
import angular = require('angular');
import { IPopupSettings } from '../../../../../../app.common/modules/common/models';
import { NotificationService } from '../../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../../app.common/modules/common/services/popup.service';
import { IStoreTableModel, IStoreTableModelWithOldName } from '../../../models';
import { ShopService } from '../../../shop.service';

export class ShopTablesList implements ng.IController {
    public static $inject = [
        'shopService',
        '$state',
        '$stateParams',
        '$uibModal',
        'popupService',
        '$translate',
        'notificationService'
    ];

    public shopName: string = null;
    public shopTown: string = null;
    public tableEnable: boolean = false;
    public waiting: boolean = false;
    public tables: IStoreTableModel[] = [];
    private tablesIDsToDelete: number[] = [];
    private shopID: number;

    constructor(
        private shopService: ShopService,
        private $state: StateService,
        private $stateParams: StateParams,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private popupService: PopupService,
        private $translate: angular.translate.ITranslateService,
        private notificationService: NotificationService,
    ) {
    }

    public $onInit() {
        if (this.$state.params.id) {
            this.shopID = this.$stateParams.id;
            this.shopName = this.$stateParams.shopName;
            this.shopTown = this.$stateParams.shopTown;
            this.loadTables().then(() => {
                if (this.$stateParams.openAddTable) {
                        this.openAddTableDialog();
                    }
                }
            );
        }
    }

    public async loadTables() {
        this.waiting = true;
        try {
            const response = await this.shopService.getTables(this.shopID);
            this.tables = response.Items;
        } catch (error) {
            console.log(error);
        } finally {
            this.waiting = false;
        }
    }

    public async deleteTable(table: IStoreTableModel) {
        try {
            await this.popupService.confirm({
                okTxt: this.$translate.instant('table_delete_dialog_cancel'),
                okClass: 'btn btn-with-background-icon close-icon--tiny24',
                cancelTxt: this.$translate.instant('table_delete_dialog_ok'),
                cancelClass: 'btn btn-with-background-icon icon-trashcan-outline-white btn-danger',
                title: this.$translate.instant('table_delete_dialog_title'),
                content: this.$translate.instant('table_delete_dialog_content'),
                invertAction: true,
                classPopup: 'popup--redesign modal360'
            } as IPopupSettings);
        } catch (error) {
            return;
        }

        this.waiting = true;
        try {
            this.tablesIDsToDelete.push(table.ID);
            const tableIndexToDelete = this.tables.findIndex((t) => t.ID === table.ID);
            this.tables.splice(tableIndexToDelete, 1);
        } catch (error) {
            console.log(error);
        } finally {
            this.waiting = false;
        }
    }

    public async openAddTableDialog() {
        const preparedTable: IStoreTableModel = await this.$uibModal.open({
            component: 'addOrEditTable',
            resolve: {
                shopID: () => this.shopID,
                isEditMode: () => false,
                existsTables: () => this.tables
            },
            size: 'md',
            backdrop: 'static',
        }).result;

        if (preparedTable) {
            this.tables.push(preparedTable);
        }
    }

    public async openEditTableDialog(table: IStoreTableModel) {
        const preparedTable: IStoreTableModelWithOldName = await this.$uibModal.open({
            component: 'addOrEditTable',
            resolve: {
                shopID: () => this.shopID,
                tableID: () => table.ID,
                tableName: () => table.Name,
                tableDescription: () => table.Description,
                existsTables: () => this.tables,
                isEditMode: () => true
            },
            size: 'md',
            backdrop: 'static',
        }).result;

        if (preparedTable) {
            const existTable = this.tables.find((t) => t.Name === preparedTable.OldName);
            existTable.Name = preparedTable.Name;
            existTable.Description = preparedTable.Description;
        }
    }

    public async save() {
        this.waiting = true;
        try {
            await this.shopService.addOrUpdateTables(this.shopID, this.tables);
            if (this.tablesIDsToDelete.length > 0) {
                await this.shopService.deleteTables(this.shopID, this.tablesIDsToDelete);
            }
            this.$state.go('app.shop', { id: this.shopID });
        } catch (error) {
            console.log(error);
            this.notificationService.showErrorMessage(error);
        } finally {
            this.waiting = false;
            this.notificationService.clearAll();
        }
    }

    public discard() {
        this.$state.go('app.shop', { id: this.shopID });
    }
}

angular.module('naut').component('shopTablesList', {
    template: require('./tables-list.component.html'),
    controller: ShopTablesList,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/places/components/shop-tables/tables-list/tables-list.component.ts